import { Empty, Spin } from 'antd'
// helper
import map from 'lodash/map'
import max from 'lodash/max'
import isEmpty from 'lodash/isEmpty'
import TransactionRecord from './TransactionRecord'
import dayjs, { Dayjs } from 'dayjs'

interface RecordListInterface {
  records: any[]
  isLoading: boolean
  dates?: Dayjs[]
}

const UserTransactionsList: React.FC<RecordListInterface> = ({
  records,
  isLoading,
  dates
}) => {
  if (isEmpty(records) && !isLoading)
    return (
      <div
        style={{ height: '258px', paddingTop: 24, overflowY: 'auto' }}
        className="flexColumn"
      >
        <Spin
          spinning
          indicator={
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: 180,
                left: 0,
                top: 'calc(50% - 90px)',
                width: '100%'
              }}
            >
              {Empty.PRESENTED_IMAGE_DEFAULT as any}
              <span style={{ color: '#888', fontSize: '1rem' }}>
                No se encontraron transacciones en el rango de fechas
              </span>
              <span style={{ color: '#888', fontSize: '1rem' }}>
                {dates[0].format('YYYY-MM-DD')} -{' '}
                {dates[1].format('YYYY-MM-DD')}
              </span>
            </div>
          }
        >
          {Array.from({ length: 6 }).map((_, i) => (
            <TransactionRecord.Skeleton
              active={false}
              key={`record-transaction-${i}`}
            />
          ))}
        </Spin>
      </div>
    )

  const emptyList = max([0, 6 - records.length])

  return (
    <div
      style={{ height: '258px', paddingTop: 24, overflowY: 'auto' }}
      className="flexColumn"
    >
      {isLoading ? (
        Array.from({ length: 6 }).map((_, i) => (
          <TransactionRecord.Skeleton key={`record-transaction-${i}`} />
        ))
      ) : (
        <>
          {map(records, (transactionRecord, i) => (
            <TransactionRecord
              date={transactionRecord.created_dt}
              points={transactionRecord.points}
              type={transactionRecord.type}
              description={transactionRecord.description}
              key={`transactionRecord-${i}`}
            />
          ))}
          {Array.from({ length: emptyList }).map((_, i) => (
            <TransactionRecord.Skeleton
              active={false}
              key={`record-transaction-${i}`}
            />
          ))}
        </>
      )}
    </div>
  )
}

export default UserTransactionsList
